import BlackFridayPromotionBackground3xImg from './black-friday-promotion-background-3x.svg';
import BlackFridayPromotionIcon3xImg from './black-friday-promotion-icon-3x.svg';
import BlackFridayPromotionBackgroundImg from './black-friday-promotion-background.svg';
import BlackFridayPromotionIconImg from './black-friday-promotion-icon.svg';
import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';
import { useSelector } from 'react-redux';
import { selectUserProfile } from '../../selectors/user';
import SidebarMenuTooltip from '../Sidebar/SidebarMenuTooltip';
import { useHistory } from 'react-router-dom';
import * as paths from '../../routes/paths';
import analytics from '../../clients/analyticsClient';

interface BlackFridayPromotionGraphicProps {
  isSidebarOpen: boolean;
}

const BlackFridayPromotionGraphic = ({
  isSidebarOpen,
}: BlackFridayPromotionGraphicProps) => {
  const currentUser = useSelector(selectUserProfile);
  const history = useHistory();

  const handleButtonClick = () => {
    analytics.trackPromoBannerCTAClicked({
      promoType: 'black_friday',
      location: 'menu_promotion_graphic',
    });
    history.push(paths.plans('pro'));
  };

  const renderExpandedContent = () => (
    <div className="relative w-[250px] aspect-[250/255]">
      <img
        src={BlackFridayPromotionIcon3xImg}
        alt="Black Friday Promotion"
        className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[58%] w-[164px] h-[113px] z-10"
      />

      <div
        className="w-full h-full flex flex-col justify-center items-center p-6 pt-[50px] rounded-3xl"
        style={{
          background: `url(${BlackFridayPromotionBackground3xImg})`,
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="flex flex-1 flex-col items-center mb-6">
          <Text
            className="bg-clip-text text-transparent text-center"
            variant="header"
            style={{
              background:
                'linear-gradient(97deg, #E8BF8B 3.85%, #BB895F 49.39%, #EED2AA 92.62%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Free Devices or 50% Off*
          </Text>
          <Text className="text-white mt-2" variant="body">
            You get to choose!
          </Text>
        </div>
        <Button
          className="bg-red-800 text-white border-red-800 hover:border-red-800 hover:bg-white hover:text-red-800 h-6 mb-2"
          fullWidth
          onPress={handleButtonClick}
        >
          Get the offer now
        </Button>
        <Text className="text-gray-500 text-[10px]" variant="caption">
          * Offer is limited to two plans.
        </Text>
      </div>
    </div>
  );

  const renderCollapsedContent = () => (
    <Button
      variant="unstyled"
      className="cursor-pointer"
      onPress={handleButtonClick}
    >
      <SidebarMenuTooltip placement="right" title="Get the offer now!" arrow>
        <div className="relative w-20 aspect-[8/7]">
          <img
            src={BlackFridayPromotionIconImg}
            alt="Black Friday Promotion"
            className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[32%] w-[112px] h-auto z-10"
          />

          <div
            className="w-full h-full flex flex-col justify-center items-center px-3 pt-[38px] pb-4 rounded-lg"
            style={{
              background: `url(${BlackFridayPromotionBackgroundImg})`,
              backgroundRepeat: 'no-repeat',
            }}
          >
            <Text
              className="text-[#E8BF8B] text-[10px] text-center font-semibold"
              variant="caption"
            >
              Limited Time Offer
            </Text>
          </div>
        </div>
      </SidebarMenuTooltip>
    </Button>
  );

  if (!currentUser) return null;

  return (
    <>{isSidebarOpen ? renderExpandedContent() : renderCollapsedContent()}</>
  );
};

export default BlackFridayPromotionGraphic;
